module.exports = "<div class=\"main-breadcrumb-wrap\">\n\t<ul class=\"main-breadcrumb align-tb\">\n\t    <li ng-repeat=\"item in $ctrl.breadcrumbsList\" ng-class=\"[{current: item.isCurrent}]\">\n\t        <a ng-click=\"$ctrl.onItemClick()\"><i class=\"icon ico-arrow-right\"></i><span>{{item.label}}</span></a>\n\t    </li>\n\t</ul>\n\t<!-- .main-breadcrumb END -->\n</div>\n<!-- .main-breadcrumb-wrap END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpMainBreadcrumb/adpMainBreadcrumb.html
// module id = 567
// module chunks = 0